<template>
    <section class="page-dashbord-tickets mt-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <all-ticked :title="'تیکت ها'"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import allTicked from "cp/dashboard-component/all-ticked.vue";

export default {
    name: 'page-dashbord-tickets',
    components: {
        allTicked
    },
    data () {
        return {
        }
    }
}
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-tickets {
  .box-clear;
}
</style>


// WEBPACK FOOTER //
// src/pages/dashboard/tickets.vue